import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useFetch from "@/lib/useFetch";
import { PageHeader, Loading, ErrorState, EmptyState } from "@/components/common";
import Crumbs from "@/components/Crumbs";
import CobrarWhatsApp from "@/components/CobrarWhatsApp";
import { saveCurrentScroll, useScrollRestore } from "@/lib/scrollRestore";
import { brl, stageColor } from "@/lib/format";

export default function Foco() {
  const { tipo } = useParams();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const ownerId = sp.get("owner_id") || "";
  const dias = sp.get("dias") || "";
  // Passa scope + limite de dias (o KPI "Parados 7d+" chega com dias=7).
  const qp = new URLSearchParams();
  if (ownerId) qp.set("owner_id", ownerId);
  if (dias) qp.set("dias", dias);
  const fetchUrl = qp.toString() ? `/foco/${tipo}?${qp.toString()}` : `/foco/${tipo}`;
  const { data, loading, error, reload } = useFetch(fetchUrl, [tipo, ownerId, dias]);

  useScrollRestore(!loading && !error);

  const openDeal = (id) => { saveCurrentScroll(); navigate(`/deal/${id}`); };

  if (loading) return <Loading />;
  if (error) return <ErrorState onRetry={reload} />;

  const items = data.items || [];

  return (
    <div>
      <Crumbs
        items={[{ label: "Requer atenção", to: "/atencao" }, { label: data.titulo }]}
        testId="foco-crumbs"
      />
      <PageHeader title={data.titulo} subtitle={`${data.subtitulo} · ${data.count === 1 ? "1 oportunidade" : `${data.count} oportunidades`} · ${brl(data.valor_total)}`} />
      {items.length === 0 ? (
        <EmptyState title="Nada por aqui" subtitle="Nenhuma oportunidade neste filtro." />
      ) : (
        <div className="space-y-2">
          {items.map((d) => {
            // "Motivo" da cobrança contextualizado pelo próprio drilldown.
            let motivo = null;
            if (d.dias_sem_movimentacao != null && d.dias_sem_movimentacao > 0)
              motivo = `sem contato há ${d.dias_sem_movimentacao} dias`;
            else if (d.proxima_atividade && d.dias_para_previsao != null && d.dias_para_previsao < 0)
              motivo = "com tarefa atrasada";
            return (
              <div key={d.id} onClick={() => openDeal(d.id)} data-testid={`foco-deal-${d.id}`}
                className="bg-card rounded-xl border border-black/5 p-4 flex items-center justify-between cursor-pointer hover:bg-slate-50 transition-colors">
                <div className="min-w-0">
                  <div className="font-medium text-navy truncate">{d.titulo}</div>
                  <div className="text-xs text-muted-foreground truncate">
                    {d.cliente_nome || "Sem cliente"} · {d.owner_name}
                    {d.dias_sem_movimentacao != null && ` · ${d.dias_sem_movimentacao}d sem movimento`}
                    {d.dias_para_previsao != null && ` · previsão ${d.dias_para_previsao}d`}
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <CobrarWhatsApp
                    vendedor={{ id: d.owner_id, name: d.owner_name, phone: d.owner_phone }}
                    cliente={d.cliente_id ? { id: d.cliente_id, nome: d.cliente_nome } : null}
                    motivo={motivo}
                    origem="atencao"
                    variant="icon"
                    testId={`foco-${d.id}`}
                  />
                  <span className="text-sm font-semibold text-navy">{brl(d.valor)}</span>
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${stageColor(d.stage)}`}>{d.stage}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
